import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Form,
  Table,
} from "react-bootstrap";
import { studyEventFormSchemaServices } from "../../../APIServices/studyEventFormSchemaServices";
import { useParams } from "react-router";
import { studyLevelFormManagementServices } from "../../../APIServices/studyLevelFormManagementServices";
import Swal from "sweetalert2";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";

const AssignRandomizationSchemaSite = () => {
  const [siteId, setSiteId] = useState("");
  const [schemaList, setSchemaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leftLoading, setLeftLoading] = useState(false);
  const [rightLoading, setRightLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteSchemaMatrix, setSiteSchemaMatrix] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [addedSchemas, setAddedSchemas] = useState([]);

  const handleAddForm = (schema) => {
    if (
      !addedSchemas.some((item) => {
        const sameForm =
          item.schemaId === schema.schemaId &&
          item.siteId === siteId;
        if (!sameForm) return false;
      })
    ) {
      setAddedSchemas((prev) => [
        ...prev,
        {
          schemaId: schema.schemaId,
          studyId,
          siteId,
        },
      ]);
    }
  };

  const handleRemoveSchema = (schemaId) => {
    setAddedSchemas((prev) =>
      prev.filter((item) => item.schemaId !== schemaId)
    );
  };

  const assignUnassignStudyRandomizationSchemaSite = async (
    schema,
    type
  ) => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.siteId = siteId;
    userData.schemaId = schema?.schemaId;
    userData.type = type;
    let data = await eiwrsRandomizationSchemaServices.assignUnassignStudyRandomizationSchemaSite(
      userData
    );
    if (data?.statusCode === 200) {
      getAssignedRandomizationSchemaBySite()
      if (type === "assigne") {
        handleAddForm(schema);
      } else {
        handleRemoveSchema(
          schema.schemaId,
        );
      }
    }
    setButtonLoader(false);
  };

  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const getStudySiteBasedonAccess = async (e) => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(
      studyId, LoginCat, StudyMode
    );
    setSiteList(data?.data || []);
    setSiteId(data?.data?.[0]?.siteId || "");
  };

  const getEIWRSRandomizationSchemaData = async (e) => {
    setRightLoading(true);
    let data = await eiwrsRandomizationSchemaServices.getEIWRSRandomizationSchemaData(
      "active",
      studyId,
      StudyMode
    );
    setSchemaList(data?.data || []);
    setRightLoading(false);
  };

  const getAssignedRandomizationSchemaBySite = async (e) => {
    setLeftLoading(true);
    let data = await eiwrsRandomizationSchemaServices.getAssignedRandomizationSchemaBySite(
      studyId,
      siteId,
    );
    setAddedSchemas(data?.data || []);
    setSiteSchemaMatrix(data?.matrixData || []);
    setLeftLoading(false);
  };

  useEffect(() => {
    if (siteId) {
      getAssignedRandomizationSchemaBySite();
    }
  }, [siteId]);

  useEffect(() => {
    getStudySiteBasedonAccess()
    getEIWRSRandomizationSchemaData()
  }, []);

  const exportMatrixCSV = () => {
    const headers = [
      "Schema",
      ...siteList.map((site) => `"${site.row.SITEID}"`),
    ];

    const rows = schemaList.map((schema) => {
      const row = [
        `"${schema?.schemaName}"`,
      ];

      siteList.forEach((site) => {
        const exists = siteSchemaMatrix.some(
          (item) =>
            item.siteId === site.siteId &&
            item.schemaId === schema.schemaId
        );

        row.push(exists ? "○" : "·");
      });

      return row.join(",");
    });

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Site_Schema_Matrix.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
      <Container fluid className="py-3">
        <Row className="mb-3">
          <Col md={7}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 border-bottom hstack justify-content-between">
                <span className="fw-bold">Assigned Schema Site</span>{" "}
                <div className="d-flex align-items-center gap-2">
                  <Form.Label className="text-muted mb-0">Site:</Form.Label>
                  <Form.Select
                    onChange={(e) => setSiteId(e.target.value)}
                    value={siteId}
                    disabled={siteList?.length === 0}
                    size="sm" style={{ flex: 1 }}>
                    {siteList?.length > 0 ? (
                      siteList?.map((item, index) => (
                        <option
                          selected={siteId === item?.siteId}
                          key={index}
                          value={item?.siteId}
                        >
                          {item?.row?.SITEID}
                        </option>
                      ))
                    ) : (
                      <option value={""}>No Site</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <Card.Body>
                <div className="d-flex flex-wrap gap-2">
                  {leftLoading ?
                    <PageLoader />
                    : addedSchemas.map((item) => {
                      const schema = schemaList.find(
                        (f) =>
                          f.schemaId === item.schemaId
                      );

                      return (
                        <Badge
                          key={item.schemaId}
                          pill
                          className="hstack gap-2 text-dark"
                          bg="primary-subtle"
                        >
                          <small>
                            {schema?.schemaName}
                          </small>

                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={() => {
                              assignUnassignStudyRandomizationSchemaSite(
                                item,
                                "unassigne"
                              )
                            }}
                          >
                            ×
                          </Button>
                        </Badge>
                      );
                    })}
                  {addedSchemas.length === 0 && (
                    <div className="text-muted text-center w-100 py-3">
                      No schemas added. Click a form Schema the library to add.
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Panel - Form Library */}
          <Col md={5}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 border-bottom hstack justify-content-between">
                <span className="fw-bold">Schema library</span>{" "}
                <span className="text-muted small">Click a Schema to add it to the selected visit.</span>{" "}
              </div>
              <Card.Body>
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {rightLoading ?
                    <PageLoader />
                    : schemaList.map((schema) => {
                      const isAdded = addedSchemas.some(
                        (f) => f.schemaId === schema.schemaId
                      );
                      return (
                        <Badge
                          key={schema.schemaId}
                          pill
                          className="hstack gap-2 text-dark"
                          bg={(!isAdded && siteId) ? "primary-subtle" : "secondary-subtle"}
                          style={{
                            cursor: (!isAdded && siteId) ? "pointer" : "default",
                            opacity: (!isAdded && siteId) ? 1 : 0.7,
                          }}
                          onClick={() => {
                            if (!isAdded && siteId) {
                              assignUnassignStudyRandomizationSchemaSite(
                                schema,
                                "assigne"
                              );
                            }
                          }}
                        >
                          <small>{schema.schemaName}</small>
                          {!isAdded ? (
                            <span className="ms-1 text-primary"> + </span>
                          ) : (
                            <span className="ms-1 text-success"> ✓</span>
                          )}
                        </Badge>
                      );
                    })}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* Site × Schema matrix */}
        <Row className="mb-3">
          <Col xs={12}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 hstack justify-content-between">
                <span className="fw-bold">Site × Schema matrix</span>
                <button onClick={exportMatrixCSV} className="updateProfile" size="sm">
                  Export matrix
                </button>
              </div>
              <Card.Body className="p-0" style={{ overflowX: "auto" }}>
                {loading ?
                  <PageLoader />
                  :
                  <>
                    <Table bordered hover size="sm" className="mb-0" style={{ fontSize: "12px", minWidth: "800px" }}>
                      <thead className="position-sticky top-0 z-1">
                        <tr>
                          <th style={{ position: "sticky", left: 0, background: "#f8f9fa", zIndex: 1 }}>Schema</th>
                          {siteList.map((site) => (
                            <th key={site.siteId} className="text-center" style={{ minWidth: "60px" }}>
                              <div>{site.row.SITEID}</div>
                              {site.row.SITENAME &&
                                <div style={{ fontSize: "9px", color: "#8aa1a9" }}>{site.row.SITENAME}</div>
                              }
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {schemaList.map((schema) => {
                          const hasSchema = addedSchemas.some(item => (item?.schemaId === schema.schemaId));
                          return (
                            <tr key={schema.id}>
                              <td style={{
                                position: "sticky",
                                left: 0,
                                background: "white",
                                zIndex: 1,
                                fontWeight: "500",
                                fontSize: "12px"
                              }}>
                                {schema.schemaName}
                              </td>
                              {siteList.map((site, colIndex) => {
                                const exists = siteSchemaMatrix.some(
                                  (item) =>
                                    item.siteId === site.siteId &&
                                    item.schemaId === schema.schemaId
                                );

                                return (
                                  <td key={colIndex} className="text-center">
                                    {exists ? (
                                      <span
                                        style={{
                                          color: "#52707a",
                                          fontSize: 16,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        ○
                                      </span>
                                    ) : (
                                      <span style={{ color: "#d8e1e5" }}>·</span>
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex gap-3 p-2" style={{ fontSize: "11px", color: "#52707a" }}>
                      <span><span style={{ color: "#52707a", fontWeight: "bold" }}>○</span> Assigned Schema</span>
                      <span><span style={{ color: "#d8e1e5" }}>·</span> Not Assigned Schema</span>
                    </div>
                  </>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AssignRandomizationSchemaSite;